import { z } from 'zod';
import { UI_STRINGS } from '@/lib/constants/ui-strings';

const P = UI_STRINGS.PROFILE;

/**
 * Replace Email dialog, step 1 (new-email entry). Company-email and
 * collision checks are the backend's `isWorkEmail()`/collision check
 * (FR-14) - this schema only validates that it looks like an email address.
 */
export const replaceEmailSchema = z.object({
  newEmail: z.string().trim().min(1, P.REPLACE_EMAIL_NEW_EMAIL_REQUIRED).email(P.REPLACE_EMAIL_NEW_EMAIL_INVALID),
});

export type ReplaceEmailFormValues = z.infer<typeof replaceEmailSchema>;
